import {useBannersContext} from '../infrastructure/BannersContext';
import {RemoteDataUI} from '../../../common/ui/RemoteDataUI';
import {Spinner} from 'react-bootstrap';
import styled from 'styled-components';
import React from 'react';

const CatalogLink = styled.a`
    display: block;
    width: 100%;
`;

const CatalogImage = styled.img`
    width: 100%;
    aspect-ratio: 9 / 2;
    height: auto;
    object-fit: cover;
    border-radius: 15px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            filter 0.25s ease;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            transform: scale(1.03);
            box-shadow: 8px 10px 25px rgba(0, 0, 0, 0.3);
            filter: brightness(1.05);
        }
    }

    @media (max-width: 576px) {
        border-radius: 12px;
    }
`;

const Grid = styled.div`
    display: grid;
    gap: 1.5rem;
    width: 100%;

    grid-template-columns: ${({ $count }) => {
        if ($count === 1) return '1fr';
        if ($count === 2) return 'repeat(2, 1fr)';
        return 'repeat(3, 1fr)';
    }};

    @media (max-width: 992px) {
        grid-template-columns: ${({ $count }) =>
            $count === 1 ? '1fr' : 'repeat(2, 1fr)'};
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`;

export const Catalogs = () => {
    const { catalogsRemoteData } = useBannersContext();

    return (
        <RemoteDataUI remoteData={catalogsRemoteData}>
            <RemoteDataUI.Pending>
                <div className="text-center"><Spinner /></div>
            </RemoteDataUI.Pending>

            <RemoteDataUI.Success>
                {catalogs => catalogs.length === 0 ? null : (
                    <Grid $count={catalogs.length}>
                        {catalogs.map((catalog, index) => (
                            <CatalogLink key={index} href={catalog.link} target="_blank" rel="noopener noreferrer">
                                <CatalogImage src={catalog.imageUrl} alt={catalog.title} />
                            </CatalogLink>
                        ))}
                    </Grid>
                )}
            </RemoteDataUI.Success>
        </RemoteDataUI>
    );
};
